import React, { useEffect } from "react";
import { object } from "prop-types";
import ErrorPage from "@components/shared/ErrorPage";

import { UNAVAILABLE_ERRORS } from "@shared/constants";

import { useRemoveQueryParameters } from "@hooks/useRemoveQueryParameters";
import { useTranslation, withTranslation } from "@lib/i18n";

const Unavailable = ({ pageProps }) => {
  const { errorId } = pageProps;
  const { t } = useTranslation();
  const removeQueryParameters = useRemoveQueryParameters();

  const getErrorMessage = () => {
    switch (errorId) {
      case UNAVAILABLE_ERRORS.FINANCE_CHECKOUT:
        return t("basket.errorMessages.financeBankIsUnavailable");

      default:
        return null;
    }
  };

  useEffect(() => {
    removeQueryParameters(["error"]);
  }, []);

  return <ErrorPage description={getErrorMessage()} />;
};

Unavailable.getInitialProps = ctx => {
  const errorId = ctx.query?.error ?? null;

  return { errorId, namespacesRequired: ["common"] };
};

Unavailable.propTypes = {
  pageProps: object,
};

export default withTranslation("common")(Unavailable);
